import { Component, OnInit } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {map, take, filter} from 'rxjs/operators';
import {AngularFireDatabase} from '@angular/fire/database';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
  ]
})
export class AppComponent {
  title = 'wosn-ott-web';
  showOverlay = false;
  isAdmin = false;
  topAlertSetting = false;
  alertMessage;
  showSponsor = false;
  constructor(public firebaseAuth: AngularFireAuth, private router: Router,  private db: AngularFireDatabase, private route: ActivatedRoute) {
    this.db.object("admin/topAlertSetting").valueChanges().subscribe((res: boolean) => {
      this.topAlertSetting = res;
    });
    this.db.object("admin/topAlertMessage").valueChanges().subscribe((res: string) => {
      this.alertMessage = res;
    });
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        // Hide loading indicator
        if (event.url === "" || event.url === "/") {
          this.showSponsor = true;
        } else {
          this.showSponsor = false;
        }
      }
    });
  }
  menuState:string = 'out';
  ngOnInit() {
    this.firebaseAuth.authState.pipe(take(1)).subscribe(auth => {
      if (auth) {
        this.db.object(`users/${auth.uid}`).valueChanges().subscribe((res: any) => {
          if (res.isAdmin) {
            this.isAdmin = true;
          } else {
            this.isAdmin = false;
          }
        });
      }
    });
  }

  logout() {
    this.firebaseAuth.auth.signOut().then((res) => {
      this.router.navigate(['/']);
    });
  }

  closeOverlay(event) {

  }

  toggleMenu() {
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
  }
}
